export default __webpack_public_path__ + "images/sleepwagen-onderwegc7b6ed248de9ad29253d37f3e8c3e0e1.svg";